import title from "../../images/integration/RPAMonitor.png";
import Parameters from "shared/components/Parameters";
import Layout from "../../components/Layout";
import { MinDigitsBrand } from "shared/components/MinDigitsBrand";
import { useEffect, useState } from "react";
import { parseImagesModule } from "shared/utils/utils.js";


export function Page({ openPopup }) {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const modules = import.meta.glob('../../images/integration/presentationRPA/*.{png,jpg,jpeg,webp,avif}', {
      eager: true,
      import: 'default'
    })
    const images = parseImagesModule(modules)
    images.sort((i1, i2) => +i1.name.replace('Page', '') - +i2.name.replace('Page', ''))
    console.log('images===', modules, images)
    setImages(images)
  }, [])
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <div className="d-flex justify-content-between flex-wrap">
            <h1 className="mb-4 ">
              АСМ РЗА (NPT RPA Monitor)
            </h1>
            <MinDigitsBrand id="2757888" />
          </div>


          <Parameters
            title=""
            image={title}
            images={images}
            openPopup={openPopup}
            zoomColor="white"
          >
            <h5 className="mb-3">Функционал экземпляра АСМ РЗА:</h5>
            <ul  >
              <li   >
                На подстанциях с АСУ ТП: реализует функцию сбора и передачи данных, необходимых для анализа функционирования РЗА, в составе АСУТП в соответствии с действующим НТД.
              </li>
              <li>На подстанциях без АСУ ТП: реализует (совместно с ПО СКСУ) сбор информации непосредственно с устройств РЗА.</li>
              <li>Осуществляет передачу на верхний уровень по протоколу ССНТИ согласно ГОСТ Р 59550-2021 "Единая энергетическая система и изолированно работающие энергосистемы. Релейная защита и автоматика СБОР, ХРАНЕНИЕ И ПЕРЕДАЧА В ДИСПЕТЧЕРСКИЕ ЦЕНТРЫ В АВТОМАТИЧЕСКОМ РЕЖИМЕ ФАЙЛОВ С ДАННЫМИ РЕГИСТРАЦИИ АВАРИЙНЫХ СОБЫТИЙ“.</li>
              <li>Получает от АСУ ТП сигналы диагностики, срабатывания и др. по протоколу МЭК 60870-5-104.</li>
              <li> Осуществляет буферизацию событий в формате XML файла с идентификаторами (mrId) CIM модели.</li>
              <li>Полученный XML файл отправляет как журнал (тип Journal)  протокола ССНТИ.</li>
              <li>Обеспечивает сбор осциллограмм внутри объекта по всем доступным протоколам передачи файлов (NFS, CIFS и т.д.).</li>
            </ul>
            <h5 className="mb-3">Особенности:</h5>
            <ul>
              <li>Работает как на отечественных ОС (Альт, Астра Linux и др.), так и на Windows.</li>
              <li> Не требует серверных мощностей, работает на промышленном ПК.</li>
              <li>Не требует установки и администрирования СУБД.</li>
            </ul>
            <a className="text-links" href="https://epsa-spb.ru/kontakty-2/">Запросить референс лист</a>
          </Parameters>
        </div>
      </div>
    </Layout>

  );
}

